export const showAlert = (message) => (dispatch) => {
  dispatch({
    type: "SHOW_ALERT",
    message: message,
  });
};

export const closeAlert = (title, message) => (dispatch) => {
  dispatch({ type: "CLOSE_ALERT" });
};
